import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { createBankWithdrawalTransaction } from '../../services'
import {
	CreateBankWithdrawalTransactionRequest,
	CreateBankWithdrawalTransactionResponse,
} from '../../../type'
import { BankMutationKeys } from '../../../keys'

type UseBaseMutationOptions<TData, TVariables> = Omit<
	UseMutationOptions<TData, Error, TVariables, unknown>,
	'mutationKey' | 'mutationFn'
>

interface UseMutationCreateBankWithdrawalTransactionProps {
	payload: CreateBankWithdrawalTransactionRequest
}

export default function useMutationCreateBankWithdrawalTransaction(
	props?: UseBaseMutationOptions<
		CreateBankWithdrawalTransactionResponse,
		UseMutationCreateBankWithdrawalTransactionProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.CreateBankWithdrawalTransaction],
		mutationFn: (params) => createBankWithdrawalTransaction(params.payload),
		...props,
	})
}
